<template>
  <b-navbar toggleable="lg">
    <div class="container">
      <router-link to="/"
        ><img
          class="img-fluid brand-logo rounded-full"
          src="../assets/images/bripl-logo.png"
      /></router-link>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <li>
            <router-link :to="{ name: 'Home' }">Home</router-link>
          </li>
          <li>
            <router-link to="">Consumers <i class="plus"></i></router-link>
            <ul class="sub-menu">
              <li>
                <a
                  :href="`${publicPath}FREETOAIRCHANNELS.pdf`"
                  download="Free to Air Channels"
                  >Free to Air Channels</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}briplpack.pdf`"
                  download="BRIPL Packages"
                  >BRIPL Packages</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}BROADCASTERBOUQUET.pdf`"
                  download="Broadcaster Packages"
                  >Broadcaster Packages</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}PAYCHANNELALACARTELIST.pdf`"
                  download="Al-A-Carte"
                  >Al-A-Carte</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}LOGICAL_CHANNEL_NUMBER.pdf`"
                  download="Logical Channel Number"
                  >Logical Channel Number</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}Network_Capacity_Documents.pdf`"
                  download="Network Capacity Document"
                  >Network Capacity Document</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}Network_Capacity_Fee_NCF.pdf`"
                  download="Network Capacity Fee"
                  >Network Capacity Fee</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}Subscription_Process_BRIPL.pdf`"
                  download="Subscription Process"
                  >Subscription Process</a
                >
              </li>
              <li>
                <a :href="`${publicPath}CPE_SCHEME.pdf`" download="CPE Scheme"
                  >CPE Scheme</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}CAP_Customer_App_Form.pdf`"
                  download="CAF : Customer App Form"
                  >CAF : Customer App Form</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}Manual_of_Practice_BRIPL.pdf`"
                  download="Manual of Practice"
                  >Manual of Practice</a
                >
              </li>
              <li>
                <a
                  :href="`${publicPath}Nodal_Office_Details.pdf`"
                  download="Nodal Office Details"
                  >Nodal Office Details</a
                >
              </li>
              <!-- Added the Broadcaster Application.pdf to consumers dropdown -->
              <li>
                <a
                  :href="`${publicPath}Broadcaster_Application_Form_BRIPL.pdf`"
                  download="Broadcaster Application Form"
                  >Broadcaster Application Form</a
                >
              </li>
            </ul>
          </li>
          <li>
            <a
              href="https://a36f8398-460f-4c08-b3f8-c2bbe28f851d.filesusr.com/ugd/a7a0dd_186b810e39134050b000cfcf3d279f6e.pdf"
              >DAS License</a
            >
          </li>
          <li>
            <router-link to="">Subscribers <i class="plus"></i></router-link>
            <ul class="sub-menu">
              <li>
                <a href="#" v-b-modal.modal-1>Online Channel Selection</a>
              </li>
              <li>
                <a
                  :href="`${publicPath}CHANNEL_SELECTION_FORM.pdf`"
                  download="Channel Selection Form"
                  >Channel Selection Form</a
                >
              </li>
              <li><a :href="`${publicPath}FAQ.pdf`" download="FAQ">FAQ</a></li>
            </ul>
          </li>
          <li>
            <router-link :to="{ name: 'Contact' }">Contact</router-link>
          </li>
          <li>
            <!-- Changed the link to "selfcare.bripl.net to .in" -->
            <div class="btn-primary-login ml-5">
              <a href="https://selfcare.bripl.in/">Customer Login</a>
            </div>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </div>
    <b-modal id="modal-1" @ok="genrateChannel" title="Online Channel Selection">
      <div class="row">
        <div class="col-md-12 col-12">
          <label>Customer Account Number</label>
          <input class="form-control" v-model="cap" />
          <!-- <b-form-select v-model="regionSelected" :options="regionOptions" size="sm" class="mb-2"></b-form-select> -->
        </div>
        <!-- <div class="col-md-12 col-12">
        <label>dp</label>
        <b-form-select v-model="dpSelected" :options="dpOptions" size="sm" class="mb-2"></b-form-select>
      </div> -->
      </div>
    </b-modal>
  </b-navbar>
</template>
<script>
const axios = require("axios");
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      regionSelected: "PRCKOLHAPUR",
      regionOptions: [
        { value: "PRCKOLHAPUR", text: "PRCKOLHAPUR" },
        { value: "PRCKOLHAPURDAS4", text: "PRCKOLHAPURDAS4" },
        { value: "PRCSATARADAS3", text: "PRCSATARADAS3" },
        { value: "PRCSATARADAS4", text: "PRCSATARADAS4" },
      ],
      dpSelected: 1,
      dpOptions: [
        { value: 1, text: "Bripl Customer" },
        { value: 2, text: "LCO Customer" },
      ],
      cap: "",
      name: "",
    };
  },
  mounted() {
    this.getName();
  },
  methods: {
    async getName() {
      const { data } = await axios.get(
        `http://bripl.ap-south-1.elasticbeanstalk.com/v1/api/customer/info/${this.cap}`
      );
      console.log("Name Data", data);
      this.name =
        data.response.result.firstname + " " + data.response.result.lastname;
    },
    genrateChannel() {
      window.open(
        `http://selfcare.bripl.in/customer-plan?name=${this.name}`,
        "_blank"
      );
    },
  },
};
</script>
<style></style>
